import { apiRoutes } from '../../apiRoutes';
import { get, post, put, remove, upload, patchUpload, downloadFile } from '../../apiServices';

interface createDirectoryInterface {
  projectId: string | undefined;
  directory: {
    name: string | null;
    parentId: string | null;
  };
}

interface uploadDrawingInterface {
  projectId: string | undefined;
  drawing: {
    name: string | null;
    parentId: string | null;
    simplifyThreshold: number | null;
  };
  file: any;
}

interface updateFileInterface {
  name?: string | null;
  status?: string;
}

export const createDirectory = async (formData: createDirectoryInterface) => {
  try {
    return await post(`${apiRoutes.directory.create}`, formData);
  } catch (error: any) {
    return error.response;
  }
};
export const uploadDrawing = async (formData: any) => {
  try {
    return await upload(`${apiRoutes.directory.uploadFile}`, formData);
  } catch (error: any) {
    return error.response;
  }
};
export const updateDrawing = async (fileId: string | undefined, formData: any) => {
  try {
    return await patchUpload(`${apiRoutes.directory.update}${fileId}`, formData);
  } catch (error: any) {
    return error.response;
  }
}

// Replace DWG file (two-step flow: upload + analyze)
export const replaceDrawing = async (fileId: string, formData: FormData) => {
  try {
    return await upload(`${apiRoutes.directory.replace}${fileId}/replace`, formData);
  } catch (error: any) {
    return error.response;
  }
};

export const reanalyzeDrawing = async (fileId: string, data: { keepAsBuilt: boolean; simplifyThreshold: number; name?: string }) => {
  try {
    return await post(`${apiRoutes.directory.replace}${fileId}/reanalyze`, data);
  } catch (error: any) {
    return error.response;
  }
};

export const getDirectoryList = async (directoryId: string | undefined) => {
  try {
    return await get(`${apiRoutes.directory.list}${directoryId}`);
  } catch (error: any) {
    return error.response;
  }
};

export const getFile = async (id: string | undefined) => {
  try {
    return await get(`${apiRoutes.directory.get}${id}`)
  } catch (error: any) {
    return error.response
  }
}

export const updateFile = async (
    id: string | undefined,
    formData: updateFileInterface,
) => {
  try {
    return await put(`${apiRoutes.directory.update}${id}`, formData);
  } catch (error: any) {
    return error.response
  }
};

export const deleteDirectoryOrFile = async (id: string | undefined) => {
  try {
    return await remove(`${apiRoutes.directory.deleteFile}${id}`);
  } catch (error: any) {
    return error.response;
  }
};

export const exportAsBuilt = async (id: string | undefined, type: string | undefined) => {
  try {
    return await downloadFile(`${apiRoutes.directory.exportAsBuilt}${id}/as-built/export?type=${type}`);
  } catch (error: any) {
    // Return error.response if available, otherwise create a fake error response
    // This handles network errors (CORS, timeout) where error.response is undefined
    if (error.response) {
      return error.response;
    }
    return { 
      status: 500, 
      data: { error: error.message || 'Network error occurred' } 
    };
  }
};

export const getConversionStatus = async (id: string | undefined) => {
  try {
    return await get(`${apiRoutes.directory.conversionStatus}${id}/conversion-status`);
  } catch (error: any) {
    return error.response;
  }
};

export const getDownloadUrl = async (id: string | undefined, type: string | undefined) => {
  try {
    return await get(`${apiRoutes.directory.downloadUrl}${id}/download?type=${type}`);
  } catch (error: any) {
    return error.response;
  }
};

// Convert drawing with user configuration (two-step flow)
export const convertDrawing = async (
  id: string | undefined,
  config: {
    sourceUnit?: string;
    excludeLayers?: string[];
    hideLayers?: string[];
    keepAsBuilt?: boolean;
  }
) => {
  try {
    return await post(`${apiRoutes.directory.convert}${id}/convert`, config);
  } catch (error: any) {
    return error.response;
  }
};
